module.exports = __webpack_public_path__ + "static/media/29ADMSPC9.8672a8e4.jpg";